/*
* Broadcast Theme – Custom JS
*/
(function () {

  function initRJ() {

    // helper: ativa shimmer quando aparecer na tela (1x), com delay p/ não brigar com parallax
    function activateOnView(el, delayMs) {
      if (!el) return;

      var delay = typeof delayMs === 'number' ? delayMs : 1500;

      // fallback sem IO
      if (!('IntersectionObserver' in window)) {
        setTimeout(function () { el.classList.add('is-active'); }, delay);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;

          setTimeout(function () {
            el.classList.add('is-active');
          }, delay);

          io.disconnect();
        });
      }, { threshold: 0.35 });

      io.observe(el);
    }

    /* ===============================
       0) BACK TO TOP – HARD FIX
       (aparece só depois de ~50% da página)
       =============================== */
    (function () {
      function ensureBtn() {
        var btn = document.querySelector('[data-scroll-top-button]');

        // Se o tema NÃO renderizar no produto, cria o botão
        if (!btn) {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'btn btn--scroll-top btn--black btn--solid';
          btn.setAttribute('aria-label', 'Voltar ao início');
          btn.setAttribute('data-scroll-top-button', '');

          btn.innerHTML =
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-up" viewBox="0 0 24 24">' +
            '<path d="M12.25 18.5V6m0 0 6 6m-6-6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '</svg>';

          document.body.appendChild(btn);
        }

        return btn;
      }

      function init() {
        var btn = ensureBtn();
        if (!btn || btn.dataset.rjReady) return;

        btn.dataset.rjReady = '1';

        btn.addEventListener('click', function () {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });

        function onScroll() {
          var doc = document.documentElement;
          var max = (doc.scrollHeight || 0) - (window.innerHeight || 0);
          if (max <= 0) { btn.classList.remove('is-visible'); return; }

          var ratio = window.scrollY / max; // 0..1
          btn.classList.toggle('is-visible', ratio >= 0.5); // metade da página
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      init();

      // Pega casos em que o tema injeta/atualiza DOM depois (produto, apps, etc.)
      var obs = new MutationObserver(function () { init(); });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    })();

    /* ===============================
       1) GRID MOBILE SLIDER (Broadcast)
       =============================== */
    document.querySelectorAll('.grid--mobile-slider').forEach(function (slider) {
      if (slider.dataset.hintInit) return;
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      slider.dataset.hintInit = "1";

      var hint = document.createElement('div');
      hint.className = 'tab-collections-hint';
      hint.innerHTML = '<div class="tab-collections-hint__bar"><div class="tab-collections-hint__fill"></div></div>';

      slider.parentNode.appendChild(hint);
      activateOnView(hint, 1500);

      var bar = hint.querySelector('.tab-collections-hint__bar');
      var fill = hint.querySelector('.tab-collections-hint__fill');

      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        if (max <= 0) { hint.style.display = 'none'; return; }
        var ratio = slider.scrollLeft / max;
        var maxOffset = bar.offsetWidth - fill.offsetWidth;
        fill.style.transform = 'translateX(' + (ratio * maxOffset) + 'px)';
      }

      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', function () { requestAnimationFrame(update); });
      update();
    });

    /* ===============================
       2) LOOK SLIDER (Custom Content)
       (apenas mobile; sem matar o resto do JS)
       =============================== */
    if (window.innerWidth <= 768) {
      document
        .querySelectorAll('section[data-section-type="custom-content"] slider-component.look__slider')
        .forEach(function (slider) {

          var slides = Array.prototype.slice.call(slider.querySelectorAll('.look__slide'));
          if (slides.length <= 1) return;

          var hint = document.createElement('div');
          hint.className = 'tab-collections-hint';
          hint.innerHTML = '<div class="tab-collections-hint__bar"><div class="tab-collections-hint__fill"></div></div>';

          slider.insertAdjacentElement('afterend', hint);
          activateOnView(hint, 450);

          var bar = hint.querySelector('.tab-collections-hint__bar');
          var fill = hint.querySelector('.tab-collections-hint__fill');

          function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

          function getIndex() {
            var sel =
              slider.querySelector('.look__slide.is-selected') ||
              slider.querySelector('.look__slide[aria-hidden="false"]');
            var i = sel ? slides.indexOf(sel) : -1;
            return i >= 0 ? i : 0;
          }

          function update() {
            var count = slides.length;
            if (count <= 1) { hint.style.display = 'none'; return; }
            var ratio = (count === 1) ? 0 : (getIndex() / (count - 1));
            var maxOffset = bar.offsetWidth - fill.offsetWidth;
            fill.style.transform = 'translateX(' + (clamp(ratio, 0, 1) * maxOffset) + 'px)';
          }

          ['settle', 'change', 'select', 'resize'].forEach(function (ev) {
            slider.addEventListener(ev, function () { requestAnimationFrame(update); }, { passive: true });
          });

          window.addEventListener('resize', function () { requestAnimationFrame(update); });
          setTimeout(update, 0);
        });
    }

    /* ===============================
       3) SHARE (funciona desktop e mobile)
       =============================== */
    window.rjShare = function () {
      var url = window.location.href;
      var cap = document.querySelector('[data-zoom-caption]');
      var title = (cap && cap.textContent ? cap.textContent.trim() : '') || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url });
      } else {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url);
        }
        alert('Link copiado');
      }
    };

  }

  // defer-safe: roda sempre
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRJ);
  } else {
    initRJ();
  }


/* ===============================
   RJ: Accordions sem flicker (sem quebrar o tema)
   - NÃO remove max-height inline
================================ */
(function () {
  function initAll() {
    document.querySelectorAll('[data-collapsible]').forEach(function (el) {
      if (el.dataset.rjCollapsible === '1') return;
      el.dataset.rjCollapsible = '1';
      el.classList.add('rj-collapsible');

      // marca aberto/fechado só pra CSS de fade (não interfere no tema)
      function sync() {
        el.classList.toggle('rj-open', el.hasAttribute('open') || el.classList.contains('is-open') || el.classList.contains('open'));
      }
      sync();

      // observa mudanças de estado
      new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open', 'class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // pega coisas que entram depois (apps/sections)
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();


/* =========================
   RJ – Show cookie banner after first scroll (robusto)
   - espera o banner ser injetado
   - só marca "shown" quando realmente mostrou
   ========================= */
(function () {
  function getBanner() {
    return document.getElementById('shopify-pc__banner');
  }

  function showBanner() {
    var el = getBanner();
    if (!el) return;
    el.classList.add('rj-pc-show');
  }

  function armScrollOnce() {
    var fired = false;

    function onScroll() {
      if (fired) return;
      if (window.scrollY < 220) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      setTimeout(showBanner, 450);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

function movePolicyLink(){
    var banner=document.getElementById('shopify-pc__banner');
    if(!banner) return;

    var policy=banner.querySelector('#shopify-pc__banner__body-policy-link');
    var manage=banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var btns=banner.querySelector('.shopify-pc__banner__btns');
    if(!policy || !manage || !btns) return;

    // remove do parágrafo (evita aparecer no meio)
    if (policy.parentNode) policy.parentNode.removeChild(policy);

    // cria box logo DEPOIS do bloco de botões (fica visualmente embaixo)
    var box=banner.querySelector('.rj-pc-links');
    if(!box){
      box=document.createElement('div');
      box.className='rj-pc-links';
      btns.insertAdjacentElement('afterend', box);
    }

    // garante ordem: Gerenciar (já existe) + Política abaixo
    box.appendChild(policy);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', movePolicyLink);
  }else{
    movePolicyLink();
  }

  function initWhenBannerExists() {
    var el = getBanner();

    // se o banner não existe, pode ser porque a Shopify já tem consentimento salvo
    // nesse caso NÃO vai aparecer mesmo.
    if (el) {
      el.classList.remove('rj-pc-show'); // garante escondido até scroll
      movePolicyLink();
      armScrollOnce();
      return;
    }

    // espera o Shopify injetar
    var obs = new MutationObserver(function () {
      var b = getBanner();
      if (!b) return;
      obs.disconnect();
      b.classList.remove('rj-pc-show');
      movePolicyLink();
      armScrollOnce();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // fail-safe: para de observar depois de 12s
    setTimeout(function () { try { obs.disconnect(); } catch(e){} }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenBannerExists);
  } else {
    initWhenBannerExists();
  }
})();


/* ===============================
   RJ – Máscara CEP (#####-###)
   - aplica só no #zipcode do Kokfy
   - funciona mesmo se o app recriar o input
================================ */
(function () {
  function formatCEP(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5);
    return digits;
  }

  function applyMask(input) {
    if (!input || input.dataset.rjCepMasked === '1') return;

    input.dataset.rjCepMasked = '1';

    input.addEventListener('input', function () {
      var v = formatCEP(input.value);
      if (input.value !== v) input.value = v;
    }, { passive: true });

    input.addEventListener('blur', function () {
      input.value = formatCEP(input.value);
    });
  }

  function init() {
    var input = document.getElementById('zipcode');
    applyMask(input);
  }

  // roda no load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // pega casos em que o app reinjeta o DOM
  var obs = new MutationObserver(init);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();



/* ===============================
   RJ – Kokfy: normaliza resultado (1 linha) + força GRÁTIS
   - Reescreve o <li> do app para markup estável
================================ */
(function () {
  function normalizeKokfyResults() {
    const carrier = document.getElementById('calc-carrier');
    if (!carrier) return;

    const items = carrier.querySelectorAll('li');
    if (!items.length) return;

    items.forEach((li) => {
      if (li.dataset.rjNormalized === '1') return;

      const nameEl = li.querySelector('.ship-name span:first-child');
      const dateEl = li.querySelector('.ship-name span:last-child');

      const rawName = (nameEl?.textContent || '').trim(); // ex: "Correios - SEDEX"
      const date = (dateEl?.textContent || '').trim();    // ex: "03/03"

      // tenta extrair serviço (SEDEX/PAC/etc) do texto do app
      let service = rawName;
      if (rawName.includes('-')) service = rawName.split('-').pop().trim();
      if (!service) service = 'SEDEX';

      // cria markup estável (grid) 100% controlável no CSS
      li.innerHTML = `
        <div class="rj-ship-left">
          <span class="rj-ship-text">Entrega em <strong>${date}</strong> via SEDEX</span>
        </div>
        <span class="rj-ship-free">Grátis</span>
      `.trim();

      li.dataset.rjNormalized = '1';
    });
  }

  // roda quando a página carrega
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeKokfyResults);
  } else {
    normalizeKokfyResults();
  }

  // roda sempre que o app atualizar o container
  const obs = new MutationObserver(() => normalizeKokfyResults());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
  


})();
